{
  "title": "Organisation details",
  "description": "The organisation name and logo shown on the tablet's waiting screen.",
  "fields": {
    "nameAr": "Organisation name in Arabic",
    "nameEn": "Organisation name in English"
  },
  "save": "Save",
  "saved": "Organisation details updated successfully",
  "logo": {
    "label": "Logo",
    "choose": "Choose image",
    "remove": "Remove logo",
    "none": "No logo",
    "hint": "A PNG or JPEG image of at most 512 KB",
    "invalid": "Choose a PNG or JPEG image of at most 512 KB",
    "uploading": "Uploading the logo...",
    "uploaded": "Logo updated successfully",
    "removed": "Logo removed successfully",
    "removeConfirmTitle": "Remove the logo?",
    "removeConfirmDescription": "The tablet's waiting screen will show no logo.",
    "alt": "{{name}} logo"
  }
}
